import React, {useState} from 'react';
import Select, {components, StylesConfig} from 'react-select';
import styles from './HeaderButtons.module.css';
import {SearchInput} from '../../../../components/SearchInput/SearchInput';

const FILTER_OPTIONS = [
    {value: 'alphabet', label: 'По алфавиту'},
    {value: 'Оценивается', label: 'По статусу: Оценивается'},
    {value: 'Выполняется', label: 'По статусу: Выполняется'},
    {value: 'Выполнено', label: 'По статусу: Выполнено'},
];

interface HeaderButtonsProps {
    selectedFilter?: string;
    onFilterChange?: (filter: string) => void;
    searchValue?: string;
    onSearchChange?: (value: string) => void;
}

export const HeaderButtons: React.FC<HeaderButtonsProps> = ({
    selectedFilter = 'alphabet', 
    onFilterChange,
    searchValue = '',
    onSearchChange
}) => {
    const [filter, setFilter] = useState(FILTER_OPTIONS.find(opt => opt.value === selectedFilter) || FILTER_OPTIONS[0]);

    const customStyles: StylesConfig<any, false> = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            border: '1px solid #AFAFAF',
            borderBottom: state.menuIsOpen ? "1px solid transparent" : '1px solid #AFAFAF',
            boxShadow: state.menuIsOpen ? '0px 4px 20px 0px rgba(0,0,0,0.08)' : 'none',
            borderRadius: state.menuIsOpen ? "16px 16px 0 0" : 16,
            minWidth: 286,
            cursor: 'pointer',
            transition: 'box-shadow 0.2s',
            padding: '14px',
            zIndex: state.menuIsOpen ? 1 : 10,
            '&:hover': {
                borderColor: '#AFAFAF',
            },
        }),
        menu: (provided) => ({
            ...provided,
            marginTop: 0,
            borderRadius: "0 0 16px 16px",
            border: '1px solid #AFAFAF',
            boxShadow: '0px 4px 20px 0px rgba(0,0,0,0.08)',
            padding: '24px',
            zIndex: 2,
            top: "65%",
            borderTop: 'none',

        }),
        option: (provided, state) => ({
            ...provided,
            background: '#fff',
            color: '#363636',
            cursor: 'pointer',
            fontSize: 16,
            padding: 0,
            fontWeight: state.isSelected ? 500 : 400,
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#363636',
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            color: '#AFAFAF',
        }),
        indicatorSeparator: () => ({display: 'none'}),
        menuList: (provided) => ({
            ...provided,
            padding: 0,
        }),
    };

    // Убираем линию у последнего элемента
    const Option = (props: any) => {
        const isLast = props.data.value === FILTER_OPTIONS[FILTER_OPTIONS.length - 1].value;
        return (
            <div style={!isLast ? {borderBottom: '1px solid #AFAFAF', padding: "12px 0"} : {padding: "12px 0 0 0"}}>
                <components.Option {...props} />
            </div>
        );
    };

    const handleChange = (selected: any) => {
        setFilter(selected);
        if (onFilterChange) onFilterChange(selected.value);
    };

    return (
        <div className={styles.buttonsContainer}>
            <SearchInput
                value={searchValue}
                onChange={onSearchChange || (() => {})}
                placeholder="Поиск по названию субъекта"
            />
            <Select
                options={FILTER_OPTIONS}
                value={filter}
                onChange={handleChange}
                isSearchable={false}
                styles={customStyles}
                components={{Option}}
                menuPlacement="auto"
            />
        </div>
    );
};
